interface ContactInfo {
    value: string;
    text: string;
    url?: string;
}

export default new class {
    primaryContactPhone: ContactInfo = {
        value: "13128880367",
        text: "(312) 888-0367"
    };

    secondaryContactPhone: ContactInfo = {
        value: "18002159444",
        text: "(800) 215-9444"
    };

    termsAndConditionsPageUrl: string = '/student-vault-terms';
};
